import ContractListServices from '@/views/ContractList/ContractListServices';
import {
  APPLY_FILTERS,
  CLEAR_FILTERS,
  SET_ITEMS,
} from './types';

export default {
  applyFilter({ commit }, filters) {
    commit(APPLY_FILTERS, filters);
  },

  async getContractList({ commit, state }) {
    const { items, total, summary } = await ContractListServices.getContractList(state.filters);

    commit(SET_ITEMS, { items, total, summary });
  },

  clearFilter({ commit }) {
    commit(CLEAR_FILTERS);
  }
};
